import { useRef, useState } from "react"
import { Box } from "@mui/material"
import { makeStyles } from "tss-react/mui"
import { faPlus } from "@fortawesome/pro-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { LocalizedStrict } from "../../../../../../../modules/localization/components/AppLocalized"
import { StandardButton } from "../../../../../buttons/StandardButton"
import { AddDeliveryTimePicker } from "./AddDeliveryTimePicker"
import { DeliveryTimeDay } from "../../../form/formTypes"

const useStyles = makeStyles()(() => ({
    iconButton: {
        padding: ".5rem",
        "& svg": {
            fontSize: "1.25rem",
        },
    },
}))

type AddDeliveryTimePickerProps = Readonly<{
    openingHours: DeliveryTimeDay[]
}>

export function AddDeliveryTimeButton({ openingHours }: AddDeliveryTimePickerProps) {
    const { classes } = useStyles()
    const [open, setOpen] = useState(false)
    const timePickerAnchor = useRef<HTMLButtonElement | null>(null)

    const handleOpenTimePicker = () => {
        setOpen(true)
    }

    return (
        <Box>
            <LocalizedStrict id="create-order-delivery-times-add-btn">
                <StandardButton
                    size="small"
                    variant="text"
                    ref={timePickerAnchor}
                    onClick={handleOpenTimePicker}
                    updateDefaultClasses={classes.iconButton}
                    startIcon={<FontAwesomeIcon icon={faPlus} />}
                >
                    Add
                </StandardButton>
            </LocalizedStrict>

            {open && (
                <AddDeliveryTimePicker
                    handleClose={() => setOpen(false)}
                    timePickerAnchor={timePickerAnchor}
                    openingHours={openingHours}
                />
            )}
        </Box>
    )
}
